// The run-time half of the gate of a feature route (ADR-0027 D1).
//
// The build holds the routes of the bought features. Two features in the
// build must still not open: a feature that the release holds of the
// deployment turn off (ADR-0027 D12), and a feature that needs an AI seat
// that the user does not hold. The session gives both. The answer is the
// NotFound page, the same as for a feature that is off, so the page tells the
// user nothing about the feature.
import type { ReactNode } from 'react';
import { useFeature } from '@septima/feature-core/react';
import type { FeatureId } from '@septima/feature-core';
import { useSession } from '@/contexts/SessionContext';
import NotFoundPage from './NotFoundPage';

export function FeatureRoute({ id, children }: { id: string; children: ReactNode }) {
    const on = useFeature(id as FeatureId);
    const { isHydrating } = useSession();
    // The holds and the seats come with the session. Until it loads, show nothing.
    if (isHydrating) return null;
    return on ? children : <NotFoundPage />;
}
